const LEAD_EXTERNAL_ENDPOINTS = [
  '/nmx-api-proxy/nmx/ms-form-proxy/lead',
  '/nmx-api-proxy/nmx/ms-form-proxy/lead-v2',
  '/nmx-api-proxy/nmx/ms-form-proxy/immediate-match',
];

const escapeRegex = (value) => value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

const isLeadExternalEndpoint = (url) => {
  if (typeof url !== 'string' || !url) {
    return false;
  }

  return LEAD_EXTERNAL_ENDPOINTS.some((path) => {
    const endpointPattern = new RegExp(`${escapeRegex(path)}(?:\\?|$)`);
    return endpointPattern.test(url);
  });
};

export default isLeadExternalEndpoint;
